class FormGenerel {
    constructor() {
        this.forms = document.querySelectorAll('[data-js="form-generel"]');

        if (this.forms) {
            this.onFormSubmit();
        }
    }

    /**
     * CLICK SUBMIT FORM
     */
    onFormSubmit() {
        let btn = document.querySelectorAll('[data-js="form-generel__submit-btn"]');
        [...btn].forEach(btn => btn.addEventListener('click', (e) => this.handleFormSubmit(e)));
    }

    /**
     * CALL API
     */
    handleFormSubmit(e) {
        e.preventDefault();
        
        let url = e.target.getAttribute('data-url'),
            $formGenerel = $(e.target).parents('[data-js="form-generel"]:first'),
            form = $formGenerel[0].querySelector('[data-js="form-generel__form"]'),
            receipt = $formGenerel[0].querySelector('[data-js="form-generel__receipt"]');

        if ($formGenerel[0].checkValidity() === false) {
            $formGenerel[0].classList.add('was-validated');
            return false;
        }

        //API CALL
        $.ajax({
            method: 'POST',
            url: url,
            data: $formGenerel.serializeArray()
        }).done(function (response) {
            if (response === true) {
                form.className += ' hide';
                $(receipt).removeClass('hide');
            }
        });

    }
}

export default FormGenerel;